import FeaturedPlayListOutlinedIcon from '@hapana/shared/web/styles/assets/svgs/credit-card-small.svg'
import TextFieldComponent from '../../../components/shared/text-field/text-field.component'
import { TEXT_FIELD_TYPE } from '../../../components/shared/text-field/text-field.constants'

const Component = (args) => {
  return <TextFieldComponent {...args}>{args.children}</TextFieldComponent>
}

export const TextField = Component.bind({})

TextField.args = {
  textFieldType: TEXT_FIELD_TYPE.TEXT,
  disabled: false,
  fullWidth: true,
  topLabel: 'Top Label',
  tooltip: 'Tooltip Title',
  maxLength: 999,
  minLength: 0,
  name: 'name',
  label: 'Label',
  id: 'textfieldid',
  helperText: 'Helper text message will be shown here',
  rules: {
    required: 'Field is required',
    maxLength: 'Field length must be less than 9',
    minLength: 'Field length must be greater than 3',
  },
  startAdornment: FeaturedPlayListOutlinedIcon,
  endAdornment: 'Kg',
  showAdornmentWithSuffix: true,
  onChange: () => {},
  placeholder: 'Enter text here...',
}

export default {
  title: 'Components',
  component: Component,
  argTypes: {
    textFieldType: {
      control: { type: 'radio', options: Object.values(TEXT_FIELD_TYPE) },
    },
  },
}
